import React from 'react';
import { Building2, Plane, Building, Factory, HeartPulse, Wallet } from 'lucide-react';
import { industries } from '../data/mock';

const iconMap = {
  Building2,
  Plane,
  Building,
  Factory,
  HeartPulse,
  Wallet
};

const Industries = () => {
  return (
    <section id="industries" className="relative py-24 bg-white overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pattern-dots" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
            <span className="text-blue-700 text-xs font-semibold uppercase tracking-wider">Industries</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4 font-display">
            Sectors We <span className="gradient-text">Serve</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Delivering specialized solutions across critical industries worldwide.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {industries.map((industry) => {
            const IconComponent = iconMap[industry.icon];
            return (
              <div
                key={industry.id}
                className="group relative p-6 rounded-2xl bg-white border border-slate-200 hover:border-blue-300 transition-all duration-300 text-center card-hover shadow-sm hover:shadow-xl hover:shadow-blue-500/10"
              >
                <div className="relative z-10">
                  <div className="w-14 h-14 mx-auto rounded-2xl bg-slate-100 group-hover:bg-gradient-to-br group-hover:from-blue-500 group-hover:to-cyan-500 flex items-center justify-center mb-4 transition-all duration-300">
                    <IconComponent className="w-7 h-7 text-slate-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-sm font-semibold text-slate-700 group-hover:text-slate-900 transition-colors leading-tight">
                    {industry.name}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
